// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { viewSelectStyles } from "@conklin/Overrides/Widgets/ProductList/ProductListViewSelect";
import IconFilterGridInactive from "@conklin/XDL/Icons/IconFilterGridInactive";
import IconFilterListInactive from "@conklin/XDL/Icons/IconFilterListInactive";
import { color } from "@conklin/XDL/Utilities";
import { IconPresentationProps } from "@insite/mobius/Icon";
import { css } from "styled-components";

const iconSharedStyle: IconPresentationProps = {
    size: 28,
    color: "common.ui4",
    css: css`
        justify-content: center;
        border: 1px solid ${color("common.ui11")};
        background-color: ${color("common.white")};
        svg {
            width: 16px;
            height: 16px;
        }
        &:hover {
            color: ${color("common.white")};
            background-color: ${color("common.ui10")};
        }
    `,
};

const iconSelectedSharedStyle: IconPresentationProps = {
    size: 28,
    color: "common.white",
    css: css`
        background-color: ${color("common.ui11")};
        justify-content: center;
        svg {
            width: 16px;
            height: 16px;
        }
    `,
};

viewSelectStyles.wrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

viewSelectStyles.listViewIcon = {
    src: IconFilterListInactive,
    ...iconSharedStyle,
};

viewSelectStyles.gridViewIcon = {
    src: IconFilterGridInactive,
    ...iconSharedStyle,
};

viewSelectStyles.listViewIconSelected = {
    src: IconFilterListInactive,
    ...iconSelectedSharedStyle,
};

viewSelectStyles.gridViewIconSelected = {
    src: IconFilterGridInactive,
    ...iconSelectedSharedStyle,
};

viewSelectStyles.listViewClickable = {
    css: css``,
};
viewSelectStyles.gridViewClickable = {};

viewSelectStyles.title = {
    size: 14,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        padding-right: 8px;
    `,
};
